<script>
	import { LayerCake, Svg, Html } from "layercake";
	import { feature } from "topojson";
	import { geoAlbersUsa } from "d3-geo";
	import { scaleQuantize } from "d3-scale";
	import { format } from "d3-format";
	import MapSvg from "./Map-svg.svelte";
	import Tooltip from "./Tooltip.svelte";
	import usStates from "./us-states-topojson.js";
	import stateData_array from "./fr.js";
	import year from "./year.js";
	import {
		LinkedIn,
		Facebook,
		Twitter,
	} from "svelte-share-buttons-component";

	// Social Media Share
	const url = "https://reason.org/topics/pension-reform/";
	const title = "...";

	const colorKey = "Funded Ratio";

	/* --------------------------------------------
	 * Create lookups to more easily join our data
	 * `dataJoinKey` is the name of the field in the data
	 * `mapJoinKey` is the name of the field in the map file
	 */
	const dataJoinKey = "name";
	const mapJoinKey = "name";
	const dataLookup = new Map();

	const geojson = feature(usStates, usStates.objects.collection);
	const projection = geoAlbersUsa;

	// 	START: MODIFIED SECTION

	//   import stateData from './us-states-data.js';
	let binCount = 21;
	$: binCount = binCount;
	$: stateData = stateData_array[binCount];
	// $: console.log(binCount)
	$: stateData.forEach((d) => {
		dataLookup.set(d[dataJoinKey], d);
		dataLookup = dataLookup;
	});
	$: console.log(year[binCount]["Year"]);
	// 	END: MODIFIED SECTION

	let evt;
	let hideTooltip = true;

	// Create a flat array of objects that LayerCake can use to measure
	// extents for the color scale
	const flatData = geojson.features.map((d) => d.properties);
	let colors = [
		"#2e3745",
		"#4a5361",
		"#68707e",
		"#878f9c",
		"#a8b0bc",
		"#cad1dc",
	];

	const addCommas = format(".1%");

	let count = 21;
	let countPlus = 21;

	function valuePlus() {
		binCount += 1;
	}

	function valueMinus() {
		binCount -= 1;
	}

	$: {
		binCount = Math.min(Math.max(binCount % 22, 0), 22);
	}
</script>

<div class="chart-container">
	<div class="social-media">
		<Facebook class="share-button" quote={title} {url} /> <br />
		<LinkedIn class="share-button" {url} /> <br />
		<Twitter class="share-button" text={title} {url} via="ReasonPensions" />
	</div>

	<div class="row">
		<div class="column1">
			<span
				style="margin-left: 10px; display:inline-block; font-size: 24px; font-weight: 700;"
				>Funded Ratio - <span style="font-size: 28px;">
					{year[binCount]["Year"]}
				</span>
					{#if year[binCount]["Year"] == 2022}
					<span style="font-style: italic; font-size: 14px;">
						(projection)
					</span>
					{/if}
					<br>
					<span style="font-weight: 400; font-style: italic; font-size: 14px;">Aggregation of State-Managed Pension Plans</span>
				</span>
			<!-- <p style="margin: 0 0 15px 10px; font-size: 14px;">
				Uses market value of pension assets over actuarially accrued
				liabilities
			</p> -->
		</div>
		<div class="column2" style="text-align: center; font-size: 11px;">
			<button class="arrow-button" on:click={valueMinus}>
				<div class="left-arrow">&#10148;</div>
			</button>
			<button class="arrow-button" on:click={valuePlus}>
				<div class="right-arrow">&#10148;</div>
			</button>
		</div>
		<div class="column3" style="margin-top: 20px; font-size: 11px;">
			<span style="position: absolute; top: 3%; right: 28.5%;">2001</span>
			<span style="position: absolute; top: 3%; right: 9%;">2022</span>
			<input
				class="range-style"
				type="range"
				min="0"
				max="21"
				step="1"
				bind:value={binCount}
			/>
		</div>
	</div>

	<div id="chart-legend" class="panel-body">
		<div class="legend-value">
			<div class="legend-block" style="background-color: #66bd63;" />
			>100%
		</div>
		<div class="legend-value">
			<div class="legend-block" style="background-color: #d9ef8b;" />
			90%-100%
		</div>
		<div class="legend-value">
			<div class="legend-block" style="background-color: #fee08b;" />
			80%-90%
		</div>
		<div class="legend-value">
			<div class="legend-block" style="background-color: #fdae61;" />
			70%-80%
		</div>
		<div class="legend-value">
			<div class="legend-block" style="background-color: #f46d43;" />
			60%-70%
		</div>
		<div class="legend-value">
			<div class="legend-block" style="background-color: #d73027;" />
			&lt;60%
		</div>
	</div>

	<!-- <div class="input-container" style="display:inline-block; position: absolute;right:10px;z-index: 9;"></div> -->
	<LayerCake
		data={geojson}
		z={(d) => dataLookup.get(d[mapJoinKey])[colorKey]}
		zScale={scaleQuantize()}
		zRange={[
			"#d73027",
			"#f46d43",
			"#fdae61",
			"#fee08b",
			"#d9ef8b",
			"#66bd63",
			"#66bd63",
		]}
		zDomain={[0.5, 1.2]}
		{flatData}
	>
		<Svg>
			<MapSvg
				{projection}
				on:mousemove={(event) => (evt = hideTooltip = event)}
				on:mouseout={() => (hideTooltip = true)}
			/>
		</Svg>

		<Html pointerEvents={false}>
			{#if hideTooltip !== true}
				<Tooltip {evt} let:detail>
					<!-- For the tooltip, do another data join because the hover event only has the data from the geography data -->
					{@const tooltipData = {
						...detail.props,
						...dataLookup.get(detail.props[mapJoinKey]),
					}}
					<div class="row" style="font-size: 16px; font-weight: 700;">
						{tooltipData["name"]}
					</div>
					<hr style="border-top: 3px solid #d3d3d3;" />
					<span style="font-size: 13px; font-weight: 600;"
						>Funded Ratio:
					</span>
					<br />
					<span style="font-size: 20px; font-weight: 800;"
						>{Math.round(tooltipData["Funded Ratio"] * 1000) / 10}%</span
					>
					{#if year[binCount]["Year"] == 2022}
					<br>
					<span style="font-style: italic; font-size: 12px; font-weight: 400;">
						Projection based on -6% investment return in 2022
					</span>
					{/if}
				</Tooltip>
			{/if}
		</Html>
	</LayerCake>
	<span class="footnote"
		>Source: <a
			href="https://reason.org/topics/pension-reform/"
			target="_blank">Reason Foundation</a
		>
		&#183;
		<a href="https://funded-ratio-map-21.vercel.app" target="_blank"
			>Link for Embed</a
		>
	</span>
</div>

<style>
	/*
		The wrapper div needs to have an explicit width and height in CSS.
		It can also be a flexbox child or CSS grid element.
		The point being it needs dimensions since the <LayerCake> element will
		expand to fill it.
	*/
	.chart-container {
		width: 92%;
		height: 83%;
	}

	.footnote {
		font-size: 11px;
	}

	a {
		color: #f63;
	}

	.column1 {
		float: left;
		width: 65%;
	}

	.column2 {
		float: left;
		width: 10%;
		margin-top: 25px;
		text-align: center;
	}

	.column3 {
		float: left;
		width: 25%;
	}

	.row:after {
		content: "";
		display: table;
		clear: both;
	}

	.social-media {
		position: absolute;
		top: 10px;
		right: 1%;
	}

	#chart-legend {
		position: absolute;
		top: 70%;
		right: 1%;
		width: 100px;
		padding: 10px;
		font-size: 12px;
	}

	.legend-value {
		margin-bottom: 4px;
	}

	.legend-block {
		width: 20px;
		height: 20px;
		float: left;
		margin-right: 10px;
		background-color: #d3d3d3;
		margin-top: -2px;
	}

</style>
